<template>
  <a-modal
    v-model:visible="visible"
    :mask-closable="false"
    :destroy-on-close="true"
    width="800px"
    centered
    :keyboard="false"
    title="Crear nuevo perfil"
    @cancel="handleCloseModal"
    :bodyStyle="{ height: '640px' }"
  >
    <CustomStepper
      :value="step"
      @update:value="step = $event"
      :items="stepsItems"
      :itemWidth="350"
      readonly
      progressDot
    />
    <!--TITULO-->
    <a-typography-title class="modal__title" :level="3">{{ steps[step].title }}</a-typography-title>
    <!--DESCRIPCION-->
    <p v-if="steps[step].description" class="modal__description container-title">
      {{ steps[step].description }}
    </p>

    <!--PRIMER PASO-->
    <div v-show="step === 0" class="container-step-1">
      <a-form class="form" ref="formRef" :model="formState" :rules="rules" layout="vertical">
        <a-row>
          <a-col :span="24">
            <div class="leftContainer">
              <a-form-item
                class="form__item form__item--large"
                label="Nombre del perfil"
                name="name"
              >
                <a-input
                  v-model:value="formState.name"
                  placeholder="Escribir nombre del perfil"
                ></a-input>
              </a-form-item>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="12">
          <a-col :span="21">
            <div class="leftContainer">
              <a-form-item label="Rol asignado" name="roleId">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.roleId"
                  placeholder="Seleccionar rol asignado"
                  @change="handleRole"
                >
                  <a-select-option :key="profilesTypes.administrator">
                    <a-popover title="Rol Administrador" trigger="hover" placement="rightBottom">
                      <template #content>
                        <div class="container__text">
                          Los perfiles asignados a este rol pueden elegir el tener acceso o no al
                          módulo de Workspace para gestionar estrategias (progresivos, predictivos,
                          IVRs, WhatsApp masivos, etc.). Además, podrán visualizar los contactos y
                          gestiones de todos los usuarios de la plataforma.
                        </div>
                      </template>

                      <div style="width: 100%">Administrador</div>
                    </a-popover>
                  </a-select-option>

                  <a-select-option :key="profilesTypes.agent">
                    <a-popover title="Rol Agente" trigger="hover" placement="rightBottom">
                      <template #content>
                        <div class="container__text">
                          Los perfiles asignados a este rol siempre tendrán acceso por defecto al
                          módulo de Workspace para gestionar estrategias masivas que sus
                          supervisores y/o administradores elijan. Solo pueden visualizar sus
                          contactos asignados.
                        </div>
                      </template>

                      <div style="width: 100%">Agente</div>
                    </a-popover>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </a-col>
          <a-col :span="3">
            <a-form-item class="form-item-icon" label="Ícono" name="icon">
              <a-select
                v-model:value="formState.icon"
              >
                <a-select-option :key="smile">
                  <img alt="profile icon" class="flag" :src="getProfileImage(smile)" />
                </a-select-option>
                <a-select-option :key="lightning">
                  <img alt="profile icon" class="flag" :src="getProfileImage(lightning)" />
                </a-select-option>
                <a-select-option :key="userIcon">
                  <img alt="profile icon" class="flag" :src="getProfileImage(userIcon)" />
                </a-select-option>
                <a-select-option :key="nut">
                  <img alt="profile icon" class="flag" :src="getProfileImage(nut)" />
                </a-select-option>
                <a-select-option :key="activity">
                  <img alt="profile icon" class="flag" :src="getProfileImage(activity)" />
                </a-select-option>
                <a-select-option :key="trophy">
                  <img alt="profile icon" class="flag" :src="getProfileImage(trophy)" />
                </a-select-option>
                <a-select-option :key="glass">
                  <img alt="profile icon" class="flag" :src="getProfileImage(glass)" />
                </a-select-option>
                <a-select-option :key="message">
                  <img alt="profile icon" class="flag" :src="getProfileImage(message)" />
                </a-select-option>
                <a-select-option :key="idcard">
                  <img alt="profile icon" class="flag" :src="getProfileImage(idcard)" />
                </a-select-option>
                <a-select-option :key="phone">
                  <img alt="profile icon" class="flag" :src="getProfileImage(phone)" />
                </a-select-option>
                <a-select-option :key="home">
                  <img alt="profile icon" class="flag" :src="getProfileImage(home)" />
                </a-select-option>
                <a-select-option :key="bulb">
                  <img alt="profile icon" class="flag" :src="getProfileImage(bulb)" />
                </a-select-option>
                <a-select-option :key="audio">
                  <img alt="profile icon" class="flag" :src="getProfileImage(audio)" />
                </a-select-option>
                <a-select-option :key="sound">
                  <img alt="profile icon" class="flag" :src="getProfileImage(sound)" />
                </a-select-option>
                <a-select-option :key="customerService">
                  <img alt="profile icon" class="flag" :src="getProfileImage(customerService)" />
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <div class="leftContainer">
              <a-form-item label="Descripción del perfil" name="observations">
                <a-textarea
                  v-model:value="formState.observations"
                  class="textarea"
                  :rows="3"
                  :maxlength="75"
                  placeholder="Escribir descripción del perfil"
                  @input="handleChangeDescription"
                />
                <span class="char-counter">{{ charCounter }}</span>
              </a-form-item>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!--SEGUNDO PASO-->
    <div v-show="step === 1" class="container-step-2">
      <a-row :gutter="24">
        <a-col :span="12">
          <div class="opciones">
            <span class="label">Módulos</span>
            <div class="modal__option">
              <a-checkbox class="entity" :checked="allCheck" @change="handleCheckAll">
                Seleccionar todo
              </a-checkbox>
              <div class="line-gray" />
              <CustomScrollbar height="355px" class="section-modules">
                <a-form-item class="form__item list-modules">
                  <div v-for="menu in menus" :key="menu.id" class="contentEntity">
                    <a-checkbox
                      class="entity"
                      :checked="isMenu(menu)"
                      :disabled="
                        menu.name === 'Workspace' && formState.roleId === profilesTypes.agent
                      "
                      @change="handleMenu($event, menu)"
                    >
                      <strong>{{ menu.name == "Entidades" ? "Empresas" : menu.name }}</strong>
                    </a-checkbox>
                    <div class="line-gray" />
                    <div v-if="menu.name === 'Workspace'" class="menu-flex">
                      <InfoCircleOutlined class="style-icon" />
                      <span class="style-text">
                        {{ textWorkspace }}
                        <router-link to="/account/security" v-if="textWorkspaceLink">
                          {{ textWorkspaceLink }}
                        </router-link>
                      </span>
                    </div>
                    <span v-for="subMenu in menu.items" :key="subMenu.id" class="portfolio">
                      <a-checkbox
                        v-if="subMenu.name != 'Entidades' || user?.customer?.type_business != 2"
                        :checked="issubMenu(subMenu)"
                        @change="handleSubMenu($event, subMenu, menu)"
                      >
                        {{ subMenu.name == "Entidades" ? "Empresas" : subMenu.name }}
                      </a-checkbox>
                    </span>
                  </div>
                </a-form-item>
              </CustomScrollbar>
            </div>
          </div>
        </a-col>
        <a-col :span="12">
          <div>
            <div class="selection">
              <span class="label">Módulos permitidos </span>
              <div class="modal__option">
                <CustomScrollbar height="380px" class="section-modules">
                  <template v-for="menu in menus" :key="menu.id" class="contentEntity">
                    <div v-if="isMenu(menu)" class="menu-flex">
                      <span class="label">
                        {{ menu.name == "Entidades" ? "Empresas" : menu.name }}
                      </span>
                      <CloseOutlined
                        v-if="menu.name != 'Workspace' || formState.roleId != profilesTypes.agent"
                        class="close-menu"
                        @click="handleCloseMenu(menu)"
                      />
                    </div>
                    <div v-if="isMenu(menu)" class="line-gray" />
                    <template v-for="subMenu in menu.items" :key="subMenu.name" class="portfolio">
                      <div v-if="issubMenu(subMenu)" class="seleccion">
                        {{ subMenu.name == "Entidades" ? "Empresas" : subMenu.name }}
                        <CloseOutlined @click="handleCloseSubMenu(subMenu, menu)" />
                      </div>
                    </template>
                  </template>
                  <div class="modules_icon" v-if="menu_id.length == 0">
                    <img
                      alt="profile icon"
                      width="100"
                      class="image-without-modules"
                      :src="getModulesImage()"
                    />
                    <span>Aún no has seleccionado ningún módulo. Selecciona mínimo 1 módulo.</span>
                  </div>                  
                </CustomScrollbar>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <!--FOOTER-->
    <template #footer>
      <a-button v-if="step == 0" @click="handleCloseModal"> Cancelar </a-button>
      <a-button v-else @click="step = 0"> Volver </a-button>
      <a-button v-if="step == 0" :disabled="isDisabled" type="primary" @click="validateForm">
        Continuar
      </a-button>
      <a-tooltip v-else-if="menu_id.length == 0">
        <template #title> Selecciona mínimo 1 módulo para crear el perfil. </template>
        <a-button
          type="primary"
          :disabled="menu_id.length == 0"
          style="margin-left: 10px;"
        >
          Crear perfil
        </a-button>
      </a-tooltip>
      <a-button
        v-else
        type="primary"
        :loading="loading"
        @click="handleOk"
      >
        Crear perfil
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { defineComponent, ref, reactive, toRaw, computed, watch, watchEffect, createVNode } from "vue";
import { useStore } from "vuex";
import { Modal } from "ant-design-vue";
import { CloseOutlined, InfoCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { RolTypes } from "@/app/shared/utils/enums";
import { menusIndex } from "@/app/users/utils/constants";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import CustomStepper from "@/app/shared/components/organisms/CustomStepper.vue";

// import modulesImage from "@/app/users/assets/profiles/modules.png";

export default defineComponent({
  components: {
    CustomScrollbar,
    CustomStepper,
    CloseOutlined,
    InfoCircleOutlined,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
  },
  setup() {
    const store = useStore();
    const formRef = ref();
    const showConfirmationModal = ref(false);
    const allCheck = ref(false);
    const step = ref(0);
    const formState = reactive({
      name: "",
      icon: "smile.svg",
      roleId: null,
      observations: "",
    });
    const textWorkspace = ref("");
    const textWorkspaceLink = ref("");
    const menu_id = ref([]);
    const profiles = computed(() => store.getters["getProfileList"]);
    const profilesTypes = RolTypes;
    const steps = [
      {
        step: "Datos del perfil",
        title: "Datos básicos del nuevo perfil",
        description: "Completa los siguientes datos.",
      },
      { step: "Permisos del perfil", title: "Seleccione los permisos para el nuevo perfil" },
    ];

    watch(formState, () => {
      showConfirmationModal.value = true;
    });

    watch(
      () => formState.roleId,
      (newRole) => {
        store.dispatch("fetchAllMenus", newRole);
      }
    );

    const checkProfiles = async (rule, value) => {
      if (value == "") {
        return Promise.reject("Campo nombre es requerido");
      } else if (profiles.value.some((item) => item.name.toLowerCase() === value.toLowerCase())) {
        return Promise.reject("Este nombre ya esta en uso");
      } else {
        return Promise.resolve();
      }
    };
    const rules = {
      name: [
        {
          required: true,
          validator: checkProfiles,
          trigger: "change",
        },
      ],
      roleId: [{ required: true, message: "Campo requerido" }],
      icon: [{ required: true, message: "Campo requerido" }],
      observations: [],
    };

    const stepsItems = steps.map((item) => item.step);

    const menus = computed(() => {
      const menus = store.getters["getMenuList"];
      const menusOrganized = [];
      for (let i = 0; i < menusIndex.length; i++) {
        const index = menus.findIndex((menu) => menu.name == menusIndex[i]);
        if (index >= 0) menusOrganized.push(menus[index]);
      }
      return menusOrganized;
    });

    watchEffect(() => {
      const menusAll = [];
      menus.value.forEach((menu) => {
        const subMenus = menu.items;
        menusAll.push(menu.id);
        subMenus.forEach((subMenu) => {
          const someone = menusAll.some((item) => item == subMenu.id);
          if (!someone) menusAll.push(subMenu.id);
        });
      });
      allCheck.value = menusAll.every(id => menu_id.value.includes(id));
      console.log({ menus: menu_id.value });
    });

    return {
      formRef,
      formState,
      rules,
      allCheck,
      textWorkspace,
      textWorkspaceLink,
      menu_id,
      step,
      profilesTypes,
      showConfirmationModal,
      stepsItems,
      steps,
      menus,
    };
  },
  data() {
    return {
      description: "",
      name: "",
      maxObservation: 75, // Máxima cantidad de caracteres en el campo de "Descripcion del perfil"
      maxObservationName: 20,
      lightning: "lightning.svg",
      userIcon: "userIcon.svg",
      nut: "nut.svg",
      activity: "activity.svg",
      trophy: "trophy.svg",
      glass: "glass.svg",
      message: "message.svg",
      idcard: "idcard.svg",
      phone: "phone.svg",
      home: "home.svg",
      bulb: "bulb.svg",
      star: "star.svg",
      customerService: "customerService.svg",
      audio: "audio.svg",
      sound: "sound.svg",
      smile: "smile.svg",
      search: "",
      loading: false,
    };
  },
  computed: {
    charCounter() {
      const total = 75;
      return `${this.formState.observations.length}/${total}`;
    },
    isDisabled() {
      return (
        this.formState.name == "" && this.formState.icon == "" && this.formState.roleId == null
      );
    },
    visible() {
      return this.value;
    },
    user() {
      return this.$store.getters["getDataUser"];
    },
  },
  methods: {
    getProfileImage(profile) {
      return new URL(`../../assets/profiles/${profile}`, import.meta.url).href;
    },
    // @/app/users/assets/profiles/modules.png
    getModulesImage() {
      return new URL(`../../assets/profiles/modules.png`, import.meta.url).href;
    },
    onSearch(query) {
      if (this.menus) {
        if (this.menus[2].items[0].id == 9 && this.user?.customer?.type_business == 2) {
          this.menus[2].items.shift();
        }
      }
      const menus = this.menus;
      let filteredMenus = menus;
      let subFiltered = [];
      if (query) {
        filteredMenus = menus.filter((menu) => {
          return menu.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
        menus.forEach((menu) => {
          const auxArray = menu.items.map((item) => {
            return item;
          });
          subFiltered = [...subFiltered, ...auxArray];
        });
        subFiltered = subFiltered.filter(
          (subMenu) => subMenu.name.toLowerCase().indexOf(query.toLowerCase()) > -1
        );
        subFiltered.forEach((subfiltrado) => {
          const elemt = menus.find((menu) => {
            return menu.id == subfiltrado.parent;
          });
          filteredMenus.push(elemt);
        });
        filteredMenus = filteredMenus.filter((v, i) => filteredMenus.indexOf(v) === i);
      }
      return filteredMenus;
    },
    onSearchItem(menu) {
      const items = menu.items;
      let array = items.filter((item) => {
        return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
      array = array ? true : false;
      return array;
    },
    handleCloseSubMenu(subMenu, menu) {
      const subMenus = menu.items;
      const index = this.menu_id.findIndex((item) => {
        return item == subMenu.id;
      });
      this.menu_id.splice(index, 1);
      const checkMenu = subMenus.some((item) => this.issubMenu(item));
      if (!checkMenu) {
        const index = this.menu_id.findIndex((item) => {
          return item == menu.id;
        });
        this.menu_id.splice(index, 1);
      }
    },
    isMenu(menu) {
      if (menu.name == "Workspace" && this.formState.roleId === this.profilesTypes.agent) {
        return true;
      } else {
        const checked = this.menu_id.includes(menu.id);
        return checked;
      }
    },
    issubMenu(subMenu) {
      if (subMenu.name == "Entidades" && this.user?.customer?.type_business == 2) {
        return false;
      } else {
        const checked = this.menu_id.includes(subMenu.id);
        return checked;
      }
    },
    handleSubMenu(e, subMenu, menu) {
      const checked = e.target.checked;
      const subMenus = menu.items;
      if (checked) {
        //TODO cuando se marque el checkbox+
        const checkeMenu = subMenus.some((item) => this.issubMenu(item));
        if (!checkeMenu && !this.isMenu(menu)) this.menu_id.push(menu.id);
        this.menu_id.push(subMenu.id);
      } else {
        //TODO cuando se desmarque el checkbox
        const index = this.menu_id.findIndex((item) => {
          return item == subMenu.id;
        });
        this.menu_id.splice(index, 1);
        const checkMenu = subMenus.some((item) => this.issubMenu(item));
        if (!checkMenu) {
          const index = this.menu_id.findIndex((item) => {
            return item == menu.id;
          });
          this.menu_id.splice(index, 1);
        }
      }
    },
    handleCloseMenu(menu) {
      if (menu.name == "Workspace") {
        Modal.confirm({
          title: "¿Estás seguro de desactivar el módulo de Workspace para este perfil?",
          icon: createVNode(QuestionCircleOutlined),
          content:
            "Recuerda que todos los usuarios asignados a este perfil ya no podrán pertenecer al listado de usuarios disponibles para gestiones masivas (colas y estrategias).",
          onCancel: () => {
            return;
          },
          onOk: () => {
            const index = this.menu_id.findIndex((item) => item == menu.id);
            const subMenus = menu.items;
            this.menu_id.splice(index, 1);
            subMenus.forEach((subMenu) => {
              const index = this.menu_id.findIndex((item) => item == subMenu.id);
              if (index != -1) this.menu_id.splice(index, 1);
            });
          },
          centered: true,
          okText: "Desactivar",
          cancelText: "Cancelar",
        });
      } else {
        const index = this.menu_id.findIndex((item) => item == menu.id);
        const subMenus = menu.items;
        this.menu_id.splice(index, 1);
        subMenus.forEach((subMenu) => {
          const index = this.menu_id.findIndex((item) => item == subMenu.id);
          if (index != -1) this.menu_id.splice(index, 1);
        });
      }
    },
    handleMenu(e, menu) {
      const checked = e.target.checked;
      const subMenus = menu.items;
      if (checked) {
        this.menu_id.push(menu.id);
        subMenus.forEach((subMenu) => {
          const someone = this.menu_id.some((item) => item == subMenu.id);
          if (!someone) this.menu_id.push(subMenu.id);
        });
      } else {
        const index = this.menu_id.findIndex((item) => item == menu.id);
        this.menu_id.splice(index, 1);
        subMenus.forEach((subMenu) => {
          const index = this.menu_id.findIndex((item) => item == subMenu.id);
          if (index != -1) this.menu_id.splice(index, 1);
        });
      }
    },
    validateForm() {
      this.formRef
        .validateFields()
        .then(() => {
          this.step = 1;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async handleOk() {
      try {
        let obj = {};
        const data = toRaw(this.formState);
        obj = {
          name: data.name,
          observations: data.observations,
          icon: data.icon,
          role: data.roleId,
          menu_id: this.menu_id,
        };
        this.loading = true;
        await this.$store.dispatch("createNewProfile", obj);
        this.loading = false;
        this.menu_id = [];
        this.step = 0;
        this.allCheck = false;
        this.formRef.resetFields();
        this.$emit("onClose");
        this.$message.success("La creación del nuevo perfil se ha realizado correctamente");
      } catch (error) {
        this.$message.error("Error al crear el perfil");
      }
    },
    handleCloseModal() {
      if (this.showConfirmationModal) {
        this.handleConfirmationClose();
      } else {
        this.handleCancel();
      }
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Deseas descartar los cambios realizados?",
        content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
        width: 450,
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Sí, descartar cambios",
        cancelText: "No, seguir editando",
      });
    },
    handleCancel() {
      this.menu_id = [];
      this.step = 0;
      this.showConfirmationModal = false;
      this.formRef.resetFields();
      this.$emit("onClose");
    },
    handleChangeDescription(event) {
      this.description = event.target.value;
    },
    handleCheckAll(event) {
      this.allCheck = event.target.checked;
      if (this.allCheck) {
        this.menus.forEach((menu) => {
          const subMenus = menu.items;
          this.menu_id.push(menu.id);
          subMenus.forEach((subMenu) => {
            const someone = this.menu_id.some((item) => item === subMenu.id);
            if (!someone) this.menu_id.push(subMenu.id);
          });
        });
      } else {
        this.menus.forEach((menu) => {
          const subMenus = menu.items;
          subMenus.forEach((subMenu) => {
            const index = this.menu_id.findIndex((item) => item == subMenu.id);
            if (index != -1) this.menu_id.splice(index, 1);
          });
        });
        this.menu_id = [];
        if (this.formState.roleId == this.profilesTypes.agent) {
          const workspace = this.menus.find((item) => item.name == "Workspace");
          this.menu_id.push(workspace.id);
        }
      }
    },
    handleRole(role) {
      if (role === this.profilesTypes.administrator) {
        this.textWorkspace =
          "Al activar el módulo de Workspace en un perfil con rol administrador, los usuarios de este perfil podrán elegir el ser listados o no en estrategias masivas para gestionar. Esto se activa en ";
        this.textWorkspaceLink = "Seguridad y Permisos.";
        this.menu_id = [];
      } else {
        this.textWorkspace =
          "Los usuarios que pertenezcan a un perfil de rol agente, siempre tendrán activo el módulo de Workspace.";
        this.textWorkspaceLink = "";
        this.menu_id.push(30); // id of workspace
      }
      this.showConfirmationModal = true;
    },
  },
});
</script>

<style lang="sass" scoped>
.container-step-2
  padding: 25px 20px 0px
.container-step-1
  padding: 25px 50px 30px

.label
  font-weight: 600
  font-size: $font-normal
  line-height: 22px
  color: $gray-9
.btn-search
  margin-bottom: 12px

.flag
  width: 20px
  filter: invert(34%) sepia(15%) saturate(0%) hue-rotate(197deg) brightness(98%) contrast(94%)
.form
  overflow: hidden
.containerRight
  background: $gray-2
  border: 1px solid $gray-4
  height: 373px
  border-radius: 3px
  padding: 10px 25px
.contentEntity
  margin-bottom: 10px
.entity
  width: 100%
  text-align: left
.portfolio
  margin-left: 28px
  margin-top: 9px
  display: flex
.seleccion
  background: $blue-1
  border: 1px solid $blue-3
  box-sizing: border-box
  border-radius: 2px
  font-size: $font-small
  line-height: 20px
  color: $gray-8
  width: 100%
  height: 30px
  display: flex
  align-items: center
  margin: 0 auto
  justify-content: space-between
  padding: 0 8px
.textarea
  position: relative
  border: 1px solid $gray-5
  border-radius: 4px
  &::placeholder
    color: $gray-6
  &:hover
    border: 1px solid $blue-5
  &:focus
    border: 1px solid $blue-5
.countername
  bottom: 0px
.counter
  bottom: 12px
.counter, .countername
  position: absolute
  right: 12px
  font-size: $font-small
  color: $gray-6
.footer
  position: absolute
  left: 0
  width: 100%
  height: 56px
  display: flex
  bottom: 0
  background: $white
  align-items: center
  justify-content: flex-end
  border-top: 1px solid $gray-5
  &__next
    margin-right: 1rem
  &__back
    margin-right: 1rem

:deep(.ant-select-selector)
  height: 70px

.image-without-modules
  display: block
  margin: 0 auto
.line-gray
  border: 1px solid #E8E8E8

.container__text
  font-size: 12px
  margin-bottom: 3px
  width: 200px
.menu-flex
  display: flex
  justify-content: space-between
  margin-top: 8px

.style-icon
  font-size: 12px
  margin-top: 3px

.style-text
  padding: 0 5px
  font-style: italic
  font-size: 12px
  color: $gray-8

.style-italic
  font-style: italic
  display: flex
.list-modules
  padding: 5px 5px 0px
.close-menu
  padding-right: 10px
  padding-top: 5px
  color: $gray-8

.section-modules
  height: calc(100% - 30px)
  margin-top: 10px
  padding-left: 8px
.char-counter
  position: absolute
  left: 92%
  top: 60%
  color: $gray-6
textarea
  resize: none

.modal
  &__title
    text-align: center
    margin: 24px auto 12px auto
  &__description
    text-align: center
    font-size: 16px
    margin-bottom: 0px
    color: $text-secondary
  &__option
    background: $white
    border: 1px solid $gray-4
    height: 410px
    padding: 8px 12px
    border-radius: 4px

.modules_icon
  height: 100%
  align-items: center
  display: flex
  flex-wrap: wrap
  align-content: center
  text-align: center

:global(.ant-popover-placement-rightBottom)
  margin-left: 20px !important
  z-index: 1200
</style>
